import {
  AggregateTaskParametersDc,
  AvailabilityAreaTaskDc,
  BufferTaskParametersDc,
  FilterCopyTaskParametersDc,
  PipelineTaskParametersDc,
  TaskProgressDc,
  TaskStatusDataDc,
  EditAttributesTaskParametersDc,
  CopyTaskParametersDc,
  UploadRasterTaskParametersDc,
} from "@evergis/api";
import { createMutation, createResource } from "@evergis/react-fetching";
import { api as evergisApi } from "../evergis/api";
import { SchedulerTask } from "../interfaces/scheduler";

export const copyTask = createMutation(
  (parameters: CopyTaskParametersDc) => async api => {
    let result: TaskStatusDataDc;

    try {
      result = await api.scheduler.startCopyTask({
        type: SchedulerTask.Copy,
        ...parameters,
      });
    } catch (e) {
      // TODO send notification
    }

    return {
      data: result,
    };
  },
  { injected: evergisApi },
);

export const calculateBuffers = createMutation(
  (parameters: BufferTaskParametersDc) => async api => ({
    data: await api.scheduler.startBufferTask({
      type: SchedulerTask.Buffer,
      ...parameters,
    }),
  }),
  { injected: evergisApi },
);

export const calculateAvailabilityArea = createMutation(
  (parameters?: AvailabilityAreaTaskDc) => async api => ({
    data: await api.scheduler.startRouteTask(parameters),
  }),
  { injected: evergisApi },
);

export const selectLayerByGeometry = createMutation(
  (parameters: FilterCopyTaskParametersDc) => async api => ({
    data: await api.scheduler.startFilterCopyTask({
      type: SchedulerTask.FilterCopy,
      ...parameters,
    }),
  }),
  { injected: evergisApi },
);

export const aggregateLayer = createMutation(
  (parameters: AggregateTaskParametersDc) => async api => ({
    data: await api.scheduler.startAggregateTask(parameters),
  }),
  { injected: evergisApi },
);

export const editAttributes = createMutation(
  (parameters: EditAttributesTaskParametersDc) => async api => ({
    data: await api.scheduler.startEditAttributesBatch(parameters),
  }),
  { injected: evergisApi },
);

export const taskProgress = createResource(
  (taskId: string) => async api => {
    let result: TaskProgressDc;

    try {
      result = await api.scheduler.getTaskProgress(taskId);
    } catch (e) {
      // TODO send notification
    }

    return {
      data: result,
    };
  },
  { injected: evergisApi },
);

export const cancelTask = createMutation(
  (taskId: string) => async api => {
    let result: TaskProgressDc;

    try {
      result = await api.scheduler.cancelTask(taskId);
    } catch (e) {
      // TODO send notification
    }

    return {
      data: result,
    };
  },
  { injected: evergisApi },
);

export const pipelineTask = createMutation(
  (parameters: PipelineTaskParametersDc) => async api => ({
    data: await api.scheduler.startPipelineTask({ type: SchedulerTask.Pipeline, ...parameters }),
  }),
  { injected: evergisApi },
);

export const tilingTask = createMutation(
  (parameters: UploadRasterTaskParametersDc) => async api => ({
    data: await api.scheduler.startTilingTask(parameters),
  }),
  { injected: evergisApi },
);
